module.exports = __webpack_public_path__ + "static/media/vizfit.f1b9f354.jpg";